/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../context/Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CheckoutBillingAccountFragment = {
  readonly __typename?: 'BillingAccount';
  readonly id: string;
  readonly description: string;
  readonly nickname: string | null;
  readonly isDefault: boolean;
  readonly cardType: Types.CardType;
};

export type RewardNotValidatedFieldsFragment = {
  readonly __typename?: 'RewardNotValidated';
  readonly message: string;
  readonly status: number;
  readonly failureCode: Types.ValidateRewardFailureCode;
};

export type ProductUnavailableFieldsFragment = {
  readonly __typename?: 'ProductUnavailable';
  readonly message: string;
  readonly status: number;
};

export type RestaurantIsNotAcceptingOrdersFieldsFragment = {
  readonly __typename?: 'RestaurantIsNotAcceptingOrders';
  readonly message: string;
  readonly status: number;
};

export type SubmitOrderMutationVariables = Types.Exact<{
  input: Types.SubmitOrderUsingBillingAccountInput;
}>;

export type SubmitOrderMutation = {
  readonly __typename?: 'Mutation';
  readonly submitOrderUsingBillingAccount:
    | { readonly __typename: 'DeliveryAlreadyInFlight' }
    | { readonly __typename: 'DeliverySpecifyAddress' }
    | { readonly __typename: 'InvalidBillingAccount' }
    | { readonly __typename: 'InvalidCustomerPhone' }
    | { readonly __typename: 'MinimumDeliverySubtotalNotMet' }
    | {
        readonly __typename: 'ProductUnavailable';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantIsNotAcceptingOrders';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RewardNotValidated';
        readonly message: string;
        readonly status: number;
        readonly failureCode: Types.ValidateRewardFailureCode;
      }
    | {
        readonly __typename: 'SubmitOrderUsingBillingAccountSuccess';
        readonly order: { readonly __typename?: 'Order'; readonly id: string };
      }
    | { readonly __typename: 'TimeslotUnavailable' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type GetAvailableWantedTimesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAvailableWantedTimesQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
  } | null;
};

export type DeliveryEstimateQueryVariables = Types.Exact<{
  input: Types.LocationByAddressInput;
}>;

export type DeliveryEstimateQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const submitOrderMutationMock: ExecutionResult<SubmitOrderMutation> = {
  data: {
    submitOrderUsingBillingAccount: { __typename: 'DeliveryAlreadyInFlight' },
  },
};

export const getAvailableWantedTimesQueryMock: ExecutionResult<GetAvailableWantedTimesQuery> =
  {
    data: {
      cart: {
        id: 'e509e6ea-9fee-442a-9962-587ce7190430',
        availableWantedTimes: [
          { time: 'Hello World' },
          { time: 'Hello World' },
        ],
      },
    },
  };

export const deliveryEstimateQueryMock: ExecutionResult<DeliveryEstimateQuery> =
  { data: { locationByAddress: { __typename: 'InvalidInput' } } };
export const CheckoutBillingAccountFragmentDoc = gql`
  fragment CheckoutBillingAccount on BillingAccount {
    id
    description
    nickname
    isDefault
    cardType
  }
`;
export const RewardNotValidatedFieldsFragmentDoc = gql`
  fragment RewardNotValidatedFields on RewardNotValidated {
    message
    status
    failureCode
  }
`;
export const ProductUnavailableFieldsFragmentDoc = gql`
  fragment ProductUnavailableFields on ProductUnavailable {
    message
    status
  }
`;
export const RestaurantIsNotAcceptingOrdersFieldsFragmentDoc = gql`
  fragment RestaurantIsNotAcceptingOrdersFields on RestaurantIsNotAcceptingOrders {
    message
    status
  }
`;
export const SubmitOrderDocument = gql`
  mutation SubmitOrder($input: SubmitOrderUsingBillingAccountInput!) {
    submitOrderUsingBillingAccount(input: $input) {
      __typename
      ... on SubmitOrderUsingBillingAccountSuccess {
        order {
          id
        }
      }
      ...ValidationErrorFields
      ...RewardNotValidatedFields
      ...ProductUnavailableFields
      ...RestaurantIsNotAcceptingOrdersFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotValidatedFieldsFragmentDoc}
  ${ProductUnavailableFieldsFragmentDoc}
  ${RestaurantIsNotAcceptingOrdersFieldsFragmentDoc}
`;

export function useSubmitOrderMutation() {
  return Urql.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(
    SubmitOrderDocument,
  );
}
export const GetAvailableWantedTimesDocument = gql`
  query getAvailableWantedTimes {
    cart {
      id
      availableWantedTimes {
        time
      }
    }
  }
`;

export function useGetAvailableWantedTimesQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetAvailableWantedTimesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetAvailableWantedTimesQuery,
    GetAvailableWantedTimesQueryVariables
  >({ query: GetAvailableWantedTimesDocument, ...options });
}
export const DeliveryEstimateDocument = gql`
  query DeliveryEstimate($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        estimateRange {
          start
          end
        }
      }
    }
  }
`;

export function useDeliveryEstimateQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryEstimateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryEstimateQuery, DeliveryEstimateQueryVariables>({
    query: DeliveryEstimateDocument,
    ...options,
  });
}
